import { render } from "./HomePagePlotix.vue?vue&type=template&id=05cef89f"
import script from "./HomePagePlotix.vue?vue&type=script&lang=js"
export * from "./HomePagePlotix.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__